<template>
  <div v-loading.fullscreen.lock="display.isLoading">
    <h3 class="centre">Total Points</h3>
    <p class="centre">{{ totalPoints }}</p>
    <div class="centre">
      <el-button class="bg-gold black" @click="onClickBack">Back</el-button>
    </div>
    <h3 class="centre">Point Transaction Details</h3>
    <div class="trx-list" v-infinite-scroll="loadNextPage" :infinite-scroll-immediate="false">
      <el-card class="trx-list__item bg-gold" v-for="trx of transactions" :key="trx._id">
        <el-row :gutter="20">
          <el-col :span="12" class="left">{{ trx.createdTimeDisplay }}</el-col>
          <el-col :span="12" class="right">{{ trx.pointDisplay }}</el-col>
        </el-row>
        <el-row class="trx-list__item__details" :gutter="20">
          <el-col :span="24" class="left">{{ trx.triggerDisplay }}</el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getTotalPoints, getPointTransactions } from "@/api/customer";
import logger from "@/utils/logger";
import { POINT_TRIGGER } from "@/utils/customer";

const name = "Points";
const log = logger(name);

export default {
  data() {
    return {
      totalPoints: 0,
      transactions: [],

      pagination: {
        page: 0,
        size: 10,
        filter: {
          createdTime: {}
        }
      },
      display: {
        isLoading: true,
        hasNextPage: true
      }
    };
  },
  async created() {
    // await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.display.isLoading = true;
      const [totalPoints, transactions] = await Promise.all([
        getTotalPoints(),
        getPointTransactions(
          this.pagination.page,
          this.pagination.size,
          this.pagination.filter
        )
      ]);
      this.totalPoints = (totalPoints || 0).toFixed(2);
      transactions.forEach(this._decorateTransaction);
      this.transactions = this.transactions.concat(transactions);
      this.display.isLoading = false;
      if (transactions.length < this.pagination.size) {
        log.info("Reach the last page");
        this.display.hasNextPage = false;
        return;
      }
    },

    async loadNextPage() {
      if (!this.display.hasNextPage) {
        return log.info("No next page");
      }
      ++this.pagination.page;
      await this.fetchData();
    },

    onClickBack() {
      this.$router.back();
    },

    _decorateTransaction(trx) {
      trx.createdTimeDisplay = moment(trx.createdTime).format(
        "HH:mm D MMM YYYY"
      );
      trx.pointDisplay = `${
        Number(trx.point) >= 0 ? "+" : "-"
      }${trx.point.toFixed(2)}`;
      trx.triggerDisplay =
        (POINT_TRIGGER[trx.trigger] && POINT_TRIGGER[trx.trigger].display) ||
        "";
    }
  }
};
</script>

<style scoped>
.trx-list {
  margin: 1rem 0.5rem 0 0.5rem;
  height: 68vh;
  overflow: auto;
}

.trx-list__item {
  margin: 0.5rem;
  padding: 0 0.2rem;
}

.trx-list__item__details {
  font-size: 0.8rem;
}
</style>